import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { LANGUAGE_CODE, type LanguageCode } from "@/constants/config";
import { getSystemSettings } from "@/services/systemSetting";

export interface SystemSettingState {
  systemLanguageCode: LanguageCode;
  ssoEnabled: boolean;
}

export const getSystemSettingsAsync = createAsyncThunk<SystemSettingState, void>(
  "systemSetting/getSystemSettings",
  async () => {
    const response = await getSystemSettings();
    return {
      systemLanguageCode: response.system_language_code,
      ssoEnabled: response.sso_enabled,
    };
  }
);

const initialState: SystemSettingState = {
  systemLanguageCode: LANGUAGE_CODE.JAPANESE,
  ssoEnabled: false,
};

const systemSettingSlice = createSlice({
  name: "systemSetting",
  initialState,
  reducers: {
    updateSystemLanguageCode: (state, action: { payload: LanguageCode }) => {
      state.systemLanguageCode = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getSystemSettingsAsync.fulfilled, (state, action) => {
      state.systemLanguageCode = action.payload.systemLanguageCode;
      state.ssoEnabled = action.payload.ssoEnabled;
    });
    builder.addCase(getSystemSettingsAsync.rejected, (state) => {
      state.systemLanguageCode = LANGUAGE_CODE.JAPANESE;
      state.ssoEnabled = false;
    });
  },
});

export const { updateSystemLanguageCode } = systemSettingSlice.actions;
export default systemSettingSlice.reducer;
